import { SVGProps } from 'react';

const IconLeftArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg width={18} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.41 5.905 5.906.41c.253-.253.6-.411.947-.411.348 0 .695.126.947.41a1.354 1.354 0 0 1 0 1.928L4.642 5.494h11.02c.757 0 1.358.6 1.358 1.358 0 .758-.6 1.359-1.358 1.359H4.642l3.19 3.19a1.354 1.354 0 0 1 0 1.927 1.354 1.354 0 0 1-1.927 0L.41 7.8C.158 7.547 0 7.2 0 6.853c0-.348.158-.695.41-.948Z"
      fill="#fff"
    />
  </svg>
);

export default IconLeftArrow;
